import { PropertyReviewStatus } from '@pms/shared';
import { cn } from '@/lib/utils';

const REVIEW_STATUS_STYLES: Record<
  PropertyReviewStatus,
  { bg: string; text: string; label: string }
> = {
  [PropertyReviewStatus.DRAFT]: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Draft' },
  [PropertyReviewStatus.PENDING_REVIEW]: {
    bg: 'bg-amber-100',
    text: 'text-amber-800',
    label: 'Pending Review',
  },
  [PropertyReviewStatus.CHANGES_REQUESTED]: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    label: 'Changes Requested',
  },
  [PropertyReviewStatus.APPROVED]: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    label: 'Approved',
  },
};

export function ReviewStatusBadge({
  status,
  className,
}: {
  status: PropertyReviewStatus;
  className?: string;
}) {
  const styles =
    REVIEW_STATUS_STYLES[status] ?? { bg: 'bg-gray-100', text: 'text-gray-600', label: status };
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium tap-auto',
        styles.bg,
        styles.text,
        className,
      )}
    >
      {styles.label}
    </span>
  );
}
